(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-game-card/assets/javascripts/components/casino-game-card-badge.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-game-card/assets/javascripts/components/casino-game-card-badge.js');

'use strict';

const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const {
  format: {
    Currency: formatCurrency
  }
} = svs.utils;
const CasinoGameCardBadge = _ref => {
  let {
    badge,
    jackpotData
  } = _ref;
  const smallScreen = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  if (badge && jackpotData !== null && jackpotData !== void 0 && jackpotData.amount) {
    return React.createElement("div", {
      className: "casino-game-card-badge"
    }, !smallScreen && React.createElement("div", {
      className: "casino-game-card-badge__text casino-game-card-badge__text--badge"
    }, badge), React.createElement("div", {
      className: "casino-game-card-badge__text casino-game-card-badge__text--jackpot casino-game-card-badge__text--alternative"
    }, formatCurrency(jackpotData.amount), ' ', "kr"));
  }
  if (badge) {
    return React.createElement("div", {
      className: "casino-game-card-badge"
    }, React.createElement("div", {
      className: "casino-game-card-badge__text"
    }, badge));
  }
  if (jackpotData !== null && jackpotData !== void 0 && jackpotData.amount) {
    return React.createElement("div", {
      className: "casino-game-card-badge"
    }, React.createElement("div", {
      className: "casino-game-card-badge__text casino-game-card-badge__text--alternative"
    }, formatCurrency(jackpotData.amount), ' ', "kr"));
  }
  return null;
};
setGlobal('svs.components.casino_react.casinoGameCard.CasinoGameCardBadge', CasinoGameCardBadge);

 })(window);